import React from 'react';
import { Loading } from '@appkit4/react-components/loading';
import './LoadingOverlay.scss';

interface LoadingOverlayProps {
    message?: string;
}

// Blocks interaction during slow navigations so the action can't be triggered twice.
const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
    message = 'Loading...',
}) => (
    <div className="loading-overlay" role="status" aria-live="polite">
        <div className="loading-overlay__content">
            <Loading loadingType="circular" indeterminate />
            <p className="loading-overlay__message">{message}</p>
        </div>
    </div>
);

export default LoadingOverlay;
